import { render, staticRenderFns } from "./SeibiExtreme.vue?vue&type=template&id=2319a74d&"
import script from "./SeibiExtreme.vue?vue&type=script&lang=ts&"
export * from "./SeibiExtreme.vue?vue&type=script&lang=ts&"
import style0 from "./SeibiExtreme.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SeibiExtreme.vue"
export default component.exports